import { motion, AnimatePresence } from "framer-motion";
import { SpinnerGap } from "@phosphor-icons/react";

const PROCESSING_MESSAGES = [
  "Reading your examples...",
  "Identifying tone patterns...",
  "Extracting your vocabulary style...",
  "Building your voice profile...",
];

export { PROCESSING_MESSAGES };

export function VoiceProcessingStep({ processingMsg }) {
  return (
    <motion.div key="processing" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex flex-col items-center justify-center py-20 space-y-8" data-testid="voice-wizard-processing">
      <div className="relative w-20 h-20">
        <SpinnerGap size={80} className="text-[#FF4400] animate-spin" />
      </div>
      <AnimatePresence mode="wait">
        <motion.p key={processingMsg} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} className="text-base text-[var(--text-secondary)] font-medium" data-testid="processing-message">
          {PROCESSING_MESSAGES[processingMsg]}
        </motion.p>
      </AnimatePresence>
      <div className="flex gap-1.5">
        {PROCESSING_MESSAGES.map((msg, i) => (
          <div key={`dot-${msg.slice(0, 15)}`} className={`w-2 h-2 rounded-full transition-colors duration-300 ${i <= processingMsg ? "bg-[#FF4400]" : "bg-[var(--border)]"}`} />
        ))}
      </div>
    </motion.div>
  );
}
